<script>
import DoughnutChart from '@components/charts/doughnut-chart.vue';
// import moment from 'moment';

export default {
  components: {
    DoughnutChart,
  },
  props: {
    thisWeeksMeals: {
      type: Array,
      required: true,
      default: () => [],
    },
    viewProgram: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      bgImg: require('@assets/images/placeholders/activity-nutrition-main.png'),
      visiblePhotoCount: 8,
      mealsDay1: [1, 2, 3, 4, 5, 6],
      mealsDay2: [1, 2, 3],
      mealsDay3: [1, 2, 3, 4],
      carbs: 25,
      fat: 36,
      protein: 80,
      chartData: {
        datasets: [
          {
            backgroundColor: ['#FACD0D', '#25EE9B', '#447EE2'],
            data: [
              this.getDailyAveraveData('carbs'),
              this.getDailyAveraveData('fat'),
              this.getDailyAveraveData('protein'),
            ],
          },
        ],
      },
      chartOpts: {
        cutoutPercentage: 80,
        tooltips: {
          enabled: false,
        },
        legend: {
          display: false,
        },
      },
    };
  },
  computed: {
    morningPhotos() {
      const morning = [];
      this.thisWeeksMeals.forEach((day) =>
        day.Breakfast.recipes.forEach((recipe) => morning.push(recipe.imageURL))
      );
      return morning;
    },
    middayPhotos() {
      const lunch = [];
      this.thisWeeksMeals.forEach((day) =>
        day.Lunch.recipes.forEach((recipe) => lunch.push(recipe.imageURL))
      );
      return lunch;
    },
    eveningPhotos() {
      const dinner = [];
      this.thisWeeksMeals.forEach((day) =>
        day.Dinner.recipes.forEach((recipe) => dinner.push(recipe.imageURL))
      );
      return dinner;
    },
  },
  mounted() {},
  methods: {
    isLastVisiblePhoto(i, arr) {
      return (
        i === this.visiblePhotoCount && arr.length > this.visiblePhotoCount
      );
    },
    nutritionImg: function() {
      return 'https://source.unsplash.com/random/900×700/?food';
    },
    getDailyAveraveData(type) {
      let dayAverage = 0;
      let dayAvailable = 0;

      this.thisWeeksMeals.forEach((day) => {
        if (
          day.aggregatedNutritionDigest &&
          day.aggregatedNutritionDigest.macroNutritionDigest &&
          day.aggregatedNutritionDigest.macroNutritionDigest[type] &&
          day.aggregatedNutritionDigest.macroNutritionDigest[type].value
        ) {
          dayAvailable += 1;
          dayAverage +=
            day.aggregatedNutritionDigest.macroNutritionDigest[type].value;
        }
      });
      return Math.round(dayAverage / dayAvailable);
    },
  },
};
</script>

<template>
  <div
    :class="[
      'card-client-progress-nutrition',
      { 'view-nutrition': !viewProgram },
    ]"
    transition
  >
    <div class="progress-section">
      <div class="progress-program-wrapper">
        <div class="progress-program-image-wrapper">
          <span class="progress-image-tag">Daily averages</span>
        </div>
        <div class="progress-program-details-chart">
          <div class="doughnut-chart-wrapper">
            <div class="doughnut-chart-data">
              <DoughnutChart
                class="doughnut-chart"
                :data="chartData"
                :options="chartOpts"
              />
            </div>
          </div>
          <div class="row progress-program-details-averages">
            <div class="col averages-wrapper">
              <div class="row">
                <div class="col">
                  <span class="num-title">Calories</span>
                </div>
                <div class="col">
                  <span class="calories">{{
                    isNaN(getDailyAveraveData('calories'))
                      ? '-'
                      : getDailyAveraveData('calories')
                  }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="num-title">Carbs</span>
                </div>
                <div class="col">
                  <span class="num">{{
                    isNaN(getDailyAveraveData('carbs'))
                      ? '-'
                      : getDailyAveraveData('carbs') + 'g'
                  }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="num-title">Protein</span>
                </div>
                <div class="col">
                  <span class="num">{{
                    isNaN(getDailyAveraveData('protein'))
                      ? '-'
                      : getDailyAveraveData('protein') + 'g'
                  }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="num-title">fat</span>
                </div>
                <div class="col">
                  <span class="num">{{
                    isNaN(getDailyAveraveData('fat'))
                      ? '-'
                      : getDailyAveraveData('fat') + 'g'
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="meal-progress-section">
      <span class="nutrition-tag">Planned Meals this Week</span>
      <div
        class="nutrition-wrapper"
        v-if="
          eveningPhotos.length === 0 &&
            middayPhotos.length === 0 &&
            morningPhotos.length === 0
        "
      >
        <span class="no-meals">No meals to display</span>
      </div>
      <div class="nutrition-wrapper">
        <div v-if="morningPhotos.length > 0" class="nutrition-day-list">
          <span>Morning</span>
          <div class="meals">
            <template v-for="(photo, i) in morningPhotos">
              <div
                :key="`${photo + i}`"
                :class="{ more: isLastVisiblePhoto(i, morningPhotos) }"
                :style="`display: ${i > visiblePhotoCount ? 'none' : 'block'}`"
              >
                <img
                  v-if="isLastVisiblePhoto(i, morningPhotos)"
                  class="icon-chevron"
                  src="@assets/images/icon-chevron-right.svg"
                />
                <img
                  v-if="!isLastVisiblePhoto(i, morningPhotos)"
                  :src="photo"
                />
              </div>
            </template>
          </div>
        </div>
        <div v-if="middayPhotos.length > 0" class="nutrition-day-list">
          <span>Midday</span>
          <div class="meals">
            <template v-for="(photo, i) in middayPhotos">
              <div
                :key="`${photo + i}`"
                :class="{ more: isLastVisiblePhoto(i, middayPhotos) }"
                :style="`display: ${i > visiblePhotoCount ? 'none' : 'block'}`"
              >
                <img
                  v-if="isLastVisiblePhoto(i, middayPhotos)"
                  class="icon-chevron"
                  src="@assets/images/icon-chevron-right.svg"
                />
                <img v-if="!isLastVisiblePhoto(i, middayPhotos)" :src="photo" />
              </div>
            </template>
          </div>
        </div>
        <div v-if="eveningPhotos.length > 0" class="nutrition-day-list">
          <span>Evening</span>
          <div class="meals">
            <template v-for="(photo, i) in eveningPhotos">
              <div
                :key="`${photo + i}`"
                :class="{ more: isLastVisiblePhoto(i, eveningPhotos) }"
                :style="`display: ${i > visiblePhotoCount ? 'none' : 'block'}`"
              >
                <img
                  v-if="isLastVisiblePhoto(i, eveningPhotos)"
                  class="icon-chevron"
                  src="@assets/images/icon-chevron-right.svg"
                />
                <img
                  v-if="!isLastVisiblePhoto(i, eveningPhotos)"
                  :src="photo"
                />
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable no-descending-specificity

.progress-program-details-averages {
  // float: right;
}

.card-client-progress-nutrition {
  background-color: white;
  border-radius: $base-border-radius-md;
  box-shadow: 0 0.4rem 0.6rem rgba($color-black-wo-rgb, 0.02);
  display: flex;
  margin-bottom: 3rem;
  min-height: 32rem;
  transform: translateX(300%);
  transition: transform 0.5s ease-in-out;
  width: 50%;
  &.view-nutrition {
    transform: translateX(-100%);
  }

  .progress-section {
    padding: 3rem 2rem;
    padding-top: 1rem;

    .doughnut-chart-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      width: 30.5%;

      @include media('xxxl', null) {
        width: 20%;
      }

      .doughnut-chart-data {
        align-items: center;
        display: flex;
        justify-content: center;
        position: relative;
        text-align: center;
        width: 100%;

        .doughnut-chart {
          width: 100%;
        }
      }
    }

    &:first-child {
      background-color: $color-light-gray;
      border-bottom-left-radius: $base-border-radius-md;
      border-top-left-radius: $base-border-radius-md;
      width: 45%;
    }

    &:last-child {
      width: 55%;
    }
  }

  .meal-progress-section {
    @extend .progress-section;

    border-bottom: 1px solid $color-light-gray-two;
    border-top: 1px solid $color-light-gray-two;
    padding-top: 1rem;
  }

  .progress-image-tag {
    background-color: rgba($color-black-wo-rgb, 0.7);
    border-radius: $base-border-radius;
    color: white;
    font-size: 1.2rem;
    font-weight: 800;
    letter-spacing: 0.1px;
    line-height: 2.2rem;
    padding: 0.25rem 0.5rem;
    text-transform: uppercase;
  }

  .nutrition-tag {
    background-color: rgba($color-black-wo-rgb, 0.7);
    border-radius: $base-border-radius;
    color: white;
    font-size: 1.2rem;
    font-weight: 800;
    letter-spacing: 0.1px;
    line-height: 2.2rem;
    padding: 0.25rem 0.5rem;
    text-transform: uppercase;
  }

  .progress-program-wrapper {
    position: relative;

    .progress-program-image-wrapper {
      // display: flex;
      // justify-content: space-between;
      // flex-direction: row-reverse;

      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      border-radius: $base-border-radius-sm;
      margin-bottom: 4%;
      max-width: 340px;
      // min-height: 140px;
      padding: 0.7rem;
      width: fit-content;
    }

    .progress-program-details {
      display: flex;

      .progress-program-title {
        flex: 1;
        padding-right: 1rem;
        text-decoration: underline;

        &:hover {
          cursor: pointer;
        }
      }

      .progress-program-completion {
        display: flex;
        flex: 1;

        .icon-chevron-wrapper {
          background-color: $color-medium-gray;
          border-radius: 50%;
          display: flex;
          height: 3.2rem;
          justify-content: center;
          overflow: hidden;
          position: absolute;
          right: 0;
          width: 3.2rem;

          &:hover {
            cursor: pointer;
          }
        }
      }
    }

    .progress-program-details-chart {
      // .averages-wrapper {
      //   width: 30rem;

      // }
      display: flex;
      justify-content: space-between;
      margin-left: 1rem;
      margin-top: 5rem;
      .progress-program-title {
        flex: 1;
        padding-right: 1rem;
        text-decoration: underline;

        &:hover {
          cursor: pointer;
        }
      }

      .progress-program-completion {
        display: flex;
        flex: 1;

        .icon-chevron-wrapper {
          background-color: $color-medium-gray;
          border-radius: 50%;
          display: flex;
          height: 3.2rem;
          justify-content: center;
          overflow: hidden;
          position: absolute;
          right: 0;
          width: 3.2rem;

          &:hover {
            cursor: pointer;
          }
        }
      }
      .progress-program-details-averages {
        color: $color-black-one;
        width: 60%;
        .num-title {
          @include calc-font-size(0.9);

          font-weight: 800;
          letter-spacing: 0.405952px;
          line-height: 3rem;
          text-transform: uppercase;
        }
        .calories {
          @include calc-font-size(1.3);

          font-weight: 800;
          letter-spacing: 0.405952px;
          line-height: 3rem;
          text-transform: uppercase;
        }
        .num {
          @include calc-font-size(0.7);

          font-weight: 600;
          letter-spacing: 0.405952px;
          line-height: 3rem;
        }
      }
    }
  }

  .nutrition-wrapper {
    .no-meals {
      background-color: rgba($color-black-wo-rgb, 0.2);
      border-radius: $base-border-radius;
      color: white;
      font-size: 1.2rem;
      font-weight: 800;
      letter-spacing: 0.1px;
      line-height: 2.2rem;
      padding: 0.25rem 0.5rem;
      text-transform: uppercase;
      width: fit-content;
    }

    display: flex;
    flex-direction: column;
    height: 100%;
    padding-bottom: 0.5rem;
    padding-top: 2rem;
    .nutrition-day-list {
      flex-grow: 1;
      margin-bottom: 0.5rem;

      span {
        color: $color-medium-gray-alt;
        font-family: $base-font-family;
        font-size: 12px;
        font-style: normal;
        font-weight: 800;
        letter-spacing: 0.1px;
        line-height: 1rem;
        text-transform: uppercase;
      }
      .meals {
        display: flex;
        flex-direction: row;
        height: 6rem;
        div {
          margin-right: 0.5rem;
          max-height: 6rem;
          max-width: 6rem;
          position: relative;
          @media screen and (max-width: 768px) {
            height: 60%;
            margin-bottom: unset;
          }
          &.more {
            background-color: $color-light-gray-twelve;
            border-radius: 6px;
            &:hover {
              cursor: pointer;
            }
          }
        }
      }
      .icon-chevron {
        height: 50%;
        left: 35%;
        position: absolute;
        top: 25%;
        width: 30%;
      }
      .nutritionImg {
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 6px;
        height: 85%;
        width: 100%;
      }
      img {
        border-radius: 6px;
        height: 100%;
        object-fit: cover;
        width: 100%;
      }
    }
  }
}
</style>
